import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess, clearApiError } from "./actions";

const generateRandomToken = () => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let token = '';
  for (let i = 0; i < 16; i++) {
    token += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return token;
};
function maskToken(token) {
  // Mask all but the first and last 4 characters of the token
  const maskedToken = token.substring(0, 1) + '************' + token.slice(-1);
  return maskedToken;
}


function* loginUser({ payload: { user, history } }) {
  try {
    // API request to real login endpoint
    const response = yield call(axios.post, `${process.env.REACT_APP_API_URL}/login/admin/`, {
      security_key: "C3RL@Pl[LsRfmqJ63_",
      data: {
        username: user.email,
        password: user.password,
      },


    });

    if (response.message === "login successfully") {

      const token = generateRandomToken();
      const maskedToken = maskToken(token);
      localStorage.setItem("token", maskedToken);  // Store random token
      // Successful login, dispatch loginSuccess
      yield put(loginSuccess(response));
      // console.log("login", response)
      yield put(clearApiError()); // Clear error on success
      history("/dashboard"); // Redirect to dashboard
    } else {
      // Handle error if login fails
      // yield put(apiError("Invalid credentials"));
      // loginUser();
      yield put(apiError(response.error || "Invalid credentials"));

    }
  } catch (error) {
    // Handle API error
    const message =
      (error.response && error.response && error.response.error) ||
      error.message ||
      "User Name or Password Incorrect";
    yield put(apiError(message));
    // yield put(apiError(error.response.message || "Login failed"));
  }


}







function* logoutUser() {
  try {
    sessionStorage.clear();

    localStorage.removeItem("token");
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      // const response = yield call(fireBaseBackend.logout);
      // yield put(logoutUserSuccess(LOGOUT_USER, response));
    } else {
      yield put(logoutUserSuccess(LOGOUT_USER, true));
    }
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);

  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
